import { computed } from 'vue';
import type { PassengerKey } from '@aviata/booking-data';

import { seatMapLib } from '@/widgets/seat-map';

import { bookingStateModel } from '@/features/booking-state';

export function useSeatMapPricesFromBooking() {
  const bookingStore = bookingStateModel.useBookingStore();

  const passengerKeysWithoutInfants = computed(() => {
    const passengersKeys = Object.keys(
      bookingStore.state.passengers,
    ) as PassengerKey[];
    return passengersKeys.filter(key => !seatMapLib.isInfant(key));
  });

  const seatMapPrice = computed(() => {
    if (!bookingStore.state.seatMap) {
      return null;
    }
    return seatMapLib.getSeatMapPrice(
      bookingStore.state.seatMap,
      passengerKeysWithoutInfants.value,
    );
  });

  const seatMapOriginalPrice = computed(() => {
    if (!bookingStore.state.seatMap) {
      return null;
    }
    return seatMapLib.getSeatMapOriginalPrice(
      bookingStore.state.seatMap,
      passengerKeysWithoutInfants.value,
    );
  });

  return { seatMapPrice, seatMapOriginalPrice };
}
